var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 87.6 25.849 c -0.003 -0.003 -0.003 -0.007 -0.006 -0.01 c -0.008 -0.008 -0.018 -0.011 -0.026 -0.019 c -1.443 -1.403 -3.408 -2.271 -5.574 -2.271 H 39.709 c -2.162 0 -4.123 0.865 -5.565 2.263 c -0.011 0.011 -0.026 0.015 -0.036 0.026 c -0.004 0.004 -0.005 0.01 -0.009 0.015 c -1.477 1.453 -2.396 3.472 -2.396 5.703 v 26.89 c 0 4.414 3.592 8.006 8.007 8.006 h 42.284 c 4.414 0 8.006 -3.592 8.006 -8.006 v -26.89 C 90 29.322 89.079 27.302 87.6 25.849 z M 81.994 25.539 c 1.237 0 2.387 0.376 3.344 1.018 L 60.852 49.02 L 36.365 26.557 c 0.957 -0.643 2.107 -1.019 3.344 -1.019 H 81.994 z M 88.009 58.446 c 0 3.317 -2.699 6.016 -6.016 6.016 H 39.709 c -3.317 0 -6.016 -2.699 -6.016 -6.016 v -26.89 c 0 -1.361 0.46 -2.614 1.225 -3.624 L 53.524 45 L 41.589 55.949 c -0.405 0.372 -0.432 1.002 -0.06 1.407 c 0.196 0.214 0.465 0.323 0.734 0.323 c 0.24 0 0.481 -0.087 0.673 -0.262 l 12.061 -11.066 l 5.182 4.754 c 0.191 0.174 0.432 0.262 0.673 0.262 s 0.482 -0.087 0.673 -0.262 l 5.182 -4.754 l 12.062 11.066 c 0.191 0.175 0.432 0.262 0.673 0.262 c 0.269 0 0.538 -0.109 0.734 -0.323 c 0.371 -0.404 0.344 -1.034 -0.061 -1.407 L 68.178 45.001 l 18.605 -17.069 c 0.765 1.009 1.225 2.263 1.225 3.624 V 58.446 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.796 45.996 H 6.573 c -0.55 0 -0.995 -0.446 -0.995 -0.995 c 0 -0.55 0.446 -0.995 0.995 -0.995 h 18.223 c 0.55 0 0.995 0.446 0.995 0.995 C 25.792 45.55 25.346 45.996 24.796 45.996 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.796 55.95 H 12.151 c -0.55 0 -0.995 -0.445 -0.995 -0.995 s 0.446 -0.995 0.995 -0.995 h 12.645 c 0.55 0 0.995 0.445 0.995 0.995 S 25.346 55.95 24.796 55.95 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.796 36.041 H 0.995 C 0.446 36.041 0 35.595 0 35.046 c 0 -0.55 0.446 -0.995 0.995 -0.995 h 23.801 c 0.55 0 0.995 0.446 0.995 0.995 C 25.792 35.595 25.346 36.041 24.796 36.041 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send-mail.d96fc529913246d01b6d51c983c9ff94.svg";
export { ForwardRef as ReactComponent };